export function assert(value, message = 'assertion failed') {
    if (!value) {
        if (typeof message === 'string') {
            throw new Error(message);
        }
        throw message;
    }
}
//# sourceMappingURL=assert.js.map